/**
 * metaSearchString — one ranked meta row, one Pokémon GO search string
 * (2026-09-10 owner ask: a magnifier on every ranked row and on the Yours
 * top ten that copies the search for that Pokémon).
 *
 * BY DEX NUMBER, never the name, for the same reasons the trade builder gives
 * (lib/tradeSearchString.ts): exact, form-proof, spelling-proof. The row's
 * build is named with the same vocabulary that builder keeps, so the two can
 * never disagree about what GO calls a filter:
 *
 *   plain row    `149&!shadow`   the ordinary copies, not the Shadow build
 *   shadow row   `149&shadow`
 *   mega row     `6&megaevolve`  a copy that can Mega Evolve
 *
 * Moves are deliberately NOT in the string. GO's `@move` search exists, but a
 * move name it does not recognise returns NOTHING, and the ranked names come
 * from a third party; a broad search the trainer narrows by eye beats an
 * empty one. The row beside the magnifier already says which moves to check.
 */
import { VARIANT_SEARCH_TOKEN } from "./tradeSearchString";

export interface MetaSearchInput {
  dexId: number;
  shadow: boolean;
  /** True for a Mega row (a raid attacker whose form starts with "Mega"). */
  mega?: boolean;
}

/** The search for one ranked row, or "" when the dex number is unusable. */
export function metaRowSearchString({ dexId, shadow, mega }: MetaSearchInput): string {
  if (!Number.isFinite(dexId) || dexId < 1) return "";
  const terms = [String(Math.trunc(dexId))];
  if (mega) terms.push(VARIANT_SEARCH_TOKEN.mega ?? "megaevolve");
  else if (shadow) terms.push(VARIANT_SEARCH_TOKEN.shadow ?? "shadow");
  else terms.push(`!${VARIANT_SEARCH_TOKEN.shadow ?? "shadow"}`);
  return terms.join("&");
}
